import DateFormattedValue from './DateFormattedValue';

export default DateFormattedValue;
